"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTabs = void 0;
var React = require("react");
var uuid_1 = require("uuid");
var Keyboard_1 = require("../../_Core/Keyboard");
var Tabs_styles_1 = require("./../Tabs.styles");
var ContentTabItem_1 = require("./ContentTabItem");
var ContentTabs = function (_a) {
    var Title = _a.Title, Data = _a.Data, _b = _a.OnChange, OnChange = _b === void 0 ? function () { } : _b, _c = _a.DefaultActiveTabIndex, DefaultActiveTabIndex = _c === void 0 ? 0 : _c;
    var defaultActiveTabIndex = DefaultActiveTabIndex > 0 && DefaultActiveTabIndex < Data.length ? DefaultActiveTabIndex : 0;
    var _d = React.useState(defaultActiveTabIndex), activeTabIndex = _d[0], setActiveTabIndex = _d[1];
    var _e = React.useState(defaultActiveTabIndex), focusTabIndex = _e[0], setFocusTabIndex = _e[1];
    var handleKeyDown = function (e) {
        if (Keyboard_1.IsDownArrow(e) || Keyboard_1.IsUpArrow(e)) {
            e.preventDefault();
            return;
        }
        var focusIndex = focusTabIndex;
        if (Keyboard_1.IsHome(e)) {
            setFocusTabIndex(0);
            return;
        }
        if (Keyboard_1.IsEnd(e)) {
            setFocusTabIndex(Data.length - 1);
            return;
        }
        if (Keyboard_1.IsLeftArrow(e)) {
            --focusIndex;
            focusIndex = focusIndex > 0 ? focusIndex : 0;
        }
        if (Keyboard_1.IsRightArrow(e)) {
            ++focusIndex;
            focusIndex = focusIndex >= Data.length ? Data.length - 1 : focusIndex;
        }
        setFocusTabIndex(focusIndex);
    };
    var tabData = Data.map(function (tabItem) { return (__assign(__assign({}, tabItem), { TabPanelId: uuid_1.v1() })); });
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs_styles_1.UL, { role: "tablist", "aria-label": Title || "" }, tabData.map(function (_a, index) {
            var Id = _a.Id, TabPanelId = _a.TabPanelId, Caption = _a.Caption;
            var handleClick = function () {
                setFocusTabIndex(index);
                setActiveTabIndex(index);
                OnChange(Data[index]);
            };
            return (React.createElement(ContentTabItem_1.ContentTabItem, { key: "tab-item-" + Id, TabPanelId: TabPanelId, Caption: Caption, IsActive: index === activeTabIndex, IsFocused: index === focusTabIndex, OnClick: handleClick, OnKeyDown: handleKeyDown }));
        })),
        React.createElement(Tabs_styles_1.TabPanelDiv, { key: "tab-panel-" + tabData[activeTabIndex].Id, id: tabData[activeTabIndex].TabPanelId, role: "tabpanel", "aria-labelledby": tabData[activeTabIndex].TabPanelId, tabIndex: 0 }, tabData[activeTabIndex].Component)));
};
exports.ContentTabs = ContentTabs;
